// «С этого устройства входили в кабинет анкеты X» (28.10.2026): кабинет
// запоминает id своей анкеты в localStorage, кнопки WhatsApp / «Позвонить»
// шлют подсказку self — клик репетитора по своей анкете не считается
// обращением родителя (contact-self.server.ts). Хранилище недоступно — просто
// без подсказки: сервер всё равно проверит cookie кабинета.

const KEY = "yt_my_partner_ids";

export function rememberMyPartner(id: string): void {
  try {
    const list = new Set<string>(JSON.parse(window.localStorage.getItem(KEY) ?? "[]"));
    list.add(id);
    window.localStorage.setItem(KEY, JSON.stringify([...list].slice(-10)));
  } catch {
    /* без хранилища — без подсказки */
  }
}

export function isMyPartner(id: string): boolean {
  try {
    return (JSON.parse(window.localStorage.getItem(KEY) ?? "[]") as string[]).includes(id);
  } catch {
    return false;
  }
}
